import "../scss/app.scss";
import { Tooltip, Popover } from "bootstrap";

// Permet de faire des foreach sur les éléments NodeList.
NodeList.prototype.forEach = Array.prototype.forEach;

document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("main_menu_btn").addEventListener("click", function () {
    document.body.classList.toggle("menu_active");
  });

  document.getElementById("main_menu_container").addEventListener("click", function (event) {
    const targetElement = event.target,
          element       = document.getElementById("main_menu_container");

    if (element === targetElement) {
      document.body.classList.toggle("menu_active");
    }
  });

  // Pour activer les tooltips et popover sur la page.
  const popoverTriggerList = [].slice.call(document.querySelectorAll("[data-bs-toggle=\"popover\"]")),
        tooltipTriggerList = [].slice.call(document.querySelectorAll("[data-bs-toggle=\"tooltip\"]"));

  popoverTriggerList.map((popoverTriggerEl) => new Popover(popoverTriggerEl));
  tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

  /* FAIRE FONCTIONNER LES MULTILINE-SELECT */
  document.querySelectorAll(".multiline-select").forEach(($element) => {
    $element.addEventListener("click", function () {
      const $radioChecked = this.querySelector("[type=\"radio\"]:checked");

      this.querySelectorAll("[type=\"radio\"]:not([name=\"\"])").forEach(($elementRadio) => {
        $elementRadio.parentElement.classList.remove("active");
      });

      if ($radioChecked) {
        const $multilineContent  = this.querySelector(".multiline-content"),
              $valueRadioChecked = this.querySelector("#value-" + $radioChecked.value);

        $radioChecked.parentElement.classList.add("active");

        if ($multilineContent && $valueRadioChecked) {
          $multilineContent.innerHTML = $valueRadioChecked.innerHTML;
        }
      }
    });
  });

  /* FAIRE FONCTIONNER LES MULTI-SELECT */

  /**
   * Permet d'afficher une valeur sur le select en fonction du nombre d'élément sélectionné.
   *
   * @param {Element} $element DOM Element du multi select
   */
  function updateMultiSelect($element) {
    const $multiContent     = $element.querySelector(".multi-content"),
          $checkboxChecked  = $element.querySelectorAll("[type=\"checkbox\"]:not([name=\"\"]):checked"),
          nbCheckboxChecked = $checkboxChecked.length;

    if ($multiContent) {
      switch (nbCheckboxChecked) {
        case 0:
          $multiContent.innerHTML = "<span class=\"text-muted\">" + $element.dataset.defaultplaceholder + "</span>";
          break;

        case 1:
          $multiContent.innerHTML = $checkboxChecked[0].parentElement.querySelector("label").innerHTML;
          break;

        default:
          $multiContent.innerHTML = nbCheckboxChecked + " sélectionnés";
      }
    }
  }

  document.querySelectorAll(".multi-select").forEach(($element) => {
    $element.addEventListener("click", function () {
      updateMultiSelect(this);
    });

    document.querySelectorAll("form").forEach(function ($formElement) {
      $formElement.addEventListener("reset", () => {
        const $multiContent = $element.querySelector(".multi-content");

        if ($multiContent) {
          $multiContent.innerHTML = "<span class=\"text-muted\">" + $element.dataset.defaultplaceholder + "</span>";
        }
      });
    });
  });
});
